module.exports = __webpack_public_path__ + "static/img/Park.1680d78f.png";